/* FiltersPanel.tsx generated by @compiled/babel-plugin v0.26.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Inline, xcss } from '@atlaskit/primitives';
import React, { Fragment, useCallback, useState } from 'react';
import { Sidebar } from '../Sidebar';
import { FiltersSelect } from './FiltersSelect';
import { SortSelect } from './SortSelect';
const wrapperStyles = xcss({
  flex: 1,
  minHeight: '0'
});
export const FiltersPanel = _ref => {
  var _filterDefinitions$, _filterOptions$select, _selectedOptions$sele;
  let {
    filterDefinitions,
    filterOptions,
    selectedOptions = {},
    sortOptions,
    selectedSortOption,
    filterStatus = {},
    onSelectedOptionsChange,
    onSelectedSortOptionChange
  } = _ref;
  const defaultSelectedOptionId = sortOptions.length > 0 ? 'sort-by' : (_filterDefinitions$ = filterDefinitions[0]) === null || _filterDefinitions$ === void 0 ? void 0 : _filterDefinitions$.filterId;
  const [selectedSidebarOptionId, setSelectedSidebarOptionId] = useState(defaultSelectedOptionId);
  const selectedFilterDefinition = filterDefinitions.find(filterDefinition => filterDefinition.filterId === selectedSidebarOptionId);
  const handleSidebarOptionClick = useCallback(id => {
    if (id !== selectedSidebarOptionId) {
      setSelectedSidebarOptionId(id);
    }
  }, [selectedSidebarOptionId]);
  return /*#__PURE__*/React.createElement(Inline, {
    xcss: wrapperStyles,
    alignBlock: "stretch"
  }, /*#__PURE__*/React.createElement(Sidebar, {
    filterDefinitions: filterDefinitions,
    selectedSidebarOptionId: selectedSidebarOptionId,
    selectedOptions: selectedOptions,
    onSidebarOptionClick: handleSidebarOptionClick,
    enableSort: sortOptions.length > 0
  }), /*#__PURE__*/React.createElement(Fragment, {
    key: selectedSidebarOptionId
  }, selectedSidebarOptionId === 'sort-by' ? /*#__PURE__*/React.createElement(SortSelect, {
    options: sortOptions,
    selectedOption: selectedSortOption !== null && selectedSortOption !== void 0 ? selectedSortOption : sortOptions[0],
    onSelectedOptionChange: onSelectedSortOptionChange
  }) : selectedFilterDefinition && /*#__PURE__*/React.createElement(FiltersSelect, {
    filterDefinition: selectedFilterDefinition,
    filterStatus: selectedSidebarOptionId ? filterStatus[selectedSidebarOptionId] : 'default',
    options: (_filterOptions$select = filterOptions[selectedSidebarOptionId]) !== null && _filterOptions$select !== void 0 ? _filterOptions$select : [],
    selectedOptions: (_selectedOptions$sele = selectedOptions[selectedSidebarOptionId]) !== null && _selectedOptions$sele !== void 0 ? _selectedOptions$sele : [],
    onSelectedOptionsChange: onSelectedOptionsChange
  })));
};